import { BASE_PATH } from "../../utils/constants";
import axios from "axios";

const baseUrl = `${BASE_PATH}/es/v1/api/auth/maintenance`;

export function apiMaintenance() {
    return axios.get(`${baseUrl}`, {})
}
